import React, {FC, useContext, useEffect} from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import Constants from '../../common/constants';
import { useStateApi } from '../../common/hooks';
import {
    AuthenticationState,
    AuthenticationStateApi,
    authenticationStateApiFactory
} from './authenticationStateApiFactory';
import { AppStoreApi, useAppStore } from '../../stores/appStore';

import DeadEnd from '@lwt-helix/dead-end';
import Card from '@lwt-helix/card';
import { Row, Col } from '@lwt-helix/layout';
import {ReadonlyAppContext} from "../app/App";
import {ReadOnlyAppContextInterface} from "../../types";

const Authentication: FC<RouteComponentProps> = (
    props: RouteComponentProps & { children?: React.ReactNode }
): React.ReactElement => {
    const { children, history } = props;

    const {
        config: {
            ui: { image }
        }
    } = useContext<ReadOnlyAppContextInterface>(ReadonlyAppContext);

    const { setQueryStringParams, getTranslation }: AppStoreApi = useAppStore();

    const stateApi = useStateApi<AuthenticationState, AuthenticationStateApi>(
        authenticationStateApiFactory,
        {
            authenticated: false
        }
    );

    useEffect((): void => {
        const params = new URLSearchParams(window.location.search);

        const clientId = params.get('clientId');
        const clientName = params.get('clientName') || '';
        const state = params.get('state') || '';
        const redirectUri = params.get('redirect_uri');

        if (clientId && redirectUri) {
            stateApi.setAuthenticated(true);

            setQueryStringParams(
                clientId,
                state,
                redirectUri,
                clientName
            );

            history.push(Constants.Routes.LOGIN);
        }
    }, []);

    return (
        <div>
            {stateApi.authenticated ? (
                children
            ) : (
                <DeadEnd
                    message={
                        <Row>
                            <Col sm={'12'} md={{ size: 6, offset: 3 }}>
                        <Card>
                            <div className="pt-3 pb-4 text-center">
                            <img
                                alt={image && image.alt}
                                src={image && image.url}
                                width="100%"
                            />
                        </div>
                            <h5 className="mb-3 text-center font-weight-normal">
                            {getTranslation(
                                Constants.Resources.Authentication
                                    .DEAD_END_MESSAGE
                            )}
                        </h5></Card></Col></Row>
                    }
                />
            )}
        </div>
    );
};

export default withRouter(Authentication);
